import React, { useState } from "react";
import {
    Box,
    Typography,
    Container,
    IconButton,
} from '@mui/material';
import {
    Close as CloseIcon,
} from '@mui/icons-material';

import { useAppContext } from "../context/AppContext";

const PrivacyPolicy = ({
    HandleClose,
}) => {
    const {
        isMobile,
        isSmallMobile,
    } = useAppContext();


    // return (
    // <Dialog
    //     open={isOpen}
    //     onClose={() => HandleClose()}
    //     maxWidth="sm"
    //     fullWidth
    //     fullScreen={isSmallMobile}
    //     PaperProps={{
    //         sx: {
    //             background: "transparent",
    //             boxShadow: 'none'
    //         }
    //     }}
    // >
    //     <Container style={{ backgroundColor: "#181818", width: isMobile ? "90%" : "40%", borderRadius: "10px" }}>
    //         <div style={{
    //             p: 2,
    //             borderBottom: '1px solid #444',
    //             width: "100%",
    //             display: "flex",
    //             justifyContent: "flex-end",
    //             alignItems: "center"
    //         }}>
    //             <Typography color="#ffffff">Terms of Use</Typography>
    //             <IconButton
    //                 onClick={() => HandleClose()}
    //                 sx={{ color: '#999', ml: 'auto' }}
    //             >
    //                 <CloseIcon />
    //             </IconButton>
    //         </div>
    //         <Box sx={{
    //             display: "flex",
    //             flexDirection: "column",
    //             justifyContent: "center",
    //             alignItems: "center",
    //         }}>

    //             <Card
    //                 sx={{
    //                     width: '100%',
    //                     maxWidth: 500,
    //                     backgroundColor: "transparent",
    //                     borderRadius: { xs: '18px', sm: '18px' },
    //                     marginTop: "18px"
    //                 }}
    //             >
    //                 <CardContent sx={{ p: { xs: 1, sm: 2 } }}>
    //                     <Typography color="#ffffff">
    //                         WHAT's U{ }
    //                     </Typography>
    //                 </CardContent>
    //             </Card>
    //         </Box>
    //     </Container>
    // </Dialog>
    // );

    return (
        <Container style={{ backgroundColor: "#303030", width: isMobile ? "95%" : "80%", borderRadius: "10px" }}>
            <div style={{
                p: 2,
                borderBottom: '1px solid #444',
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                textAlign: "center",
                padding: "8px 0px"
            }}>
                <Typography fontSize={"32px"} color="#ffffff" width={"100%"}>Privacy Policy</Typography>
                <IconButton
                    onClick={() => HandleClose()}
                    sx={{ color: '#999', ml: 'auto' }}
                >
                    <CloseIcon />
                </IconButton>
            </div>
            <Box sx={{
                // display: "flex",
                // flexDirection: "column",
                // justifyContent: "center",
                // alignItems: "center",
                padding: "10px 10px",
                height: isMobile ? "50vh" : "60vh",
                overflow: 'auto',
                scrollbarWidth: "thin",
                scrollbarColor: "rgba(255, 255, 255, 0.3) transparent",
            }}>
                <Typography fontSize="18px" color="#ffffff" my="10px">
                    Important: The telemedicine consent confirms you understand the risks, benefits and limits of a telemedicine PME. The evaluation
                    supports medical hiring physician's decisions but does not replace emergency care or ongoing treatment from your physician. Please ask
                    questions about the process at any time. Get Sl informed.
                </Typography>
                <Typography fontSize="18px" color="#ffffff" my="10px">
                    Important: The telemedicine consent confirms you understand the risks, benefits and limits of a telemedicine PME. The evaluation
                    supports medical hiring physician's decisions but does not replace emergency care or ongoing treatment from your physician. Please ask
                    questions about the process at any time. Get Sl informed.
                </Typography>
                <Typography fontSize="18px" color="#ffffff" my="10px">
                    Important: The telemedicine consent confirms you understand the risks, benefits and limits of a telemedicine PME. The evaluation
                    supports medical hiring physician's decisions but does not replace emergency care or ongoing treatment from your physician. Please ask
                    questions about the process at any time. Get Sl informed.
                </Typography>
                <Typography fontSize="18px" color="#ffffff" my="10px">
                    Important: The telemedicine consent confirms you understand the risks, benefits and limits of a telemedicine PME. The evaluation
                    supports medical hiring physician's decisions but does not replace emergency care or ongoing treatment from your physician. Please ask
                    questions about the process at any time. Get Sl informed.
                </Typography>
            </Box>
        </Container>
    );
};

export default PrivacyPolicy;